<template>
 <div style="width:100%;">
     <PDFViewer :pdfUrl="pdfUrl" />
     
 </div>
   
</template>

<script>
import pdfjsLib from 'pdfjs-dist';
import PDFViewer from '@/components/PDFViewer.vue'
export default {
  name: 'PdfsView',
   components: {
      PDFViewer
    },
  data(){
    return{
      baseurl:'../../assets/1.pdf',
      pdfUrl: '/1.pdf'
    }
  },
  mounted() {
   
  }
}
</script>


<style>

</style>